<template>
  <div class="home">
    <div>
      <!-- Image and text -->
      <b-navbar toggleable="lg" class="fixed-top pr-0 pt-0 pb-0 mb-5">
        <b-navbar-brand>
          <img src="../assets/ICDL_bleu_sans_marge.png" />
        </b-navbar-brand>
        <b-navbar-toggle target="nav_collapse">
          <span class="navbar-toggler-icon" />
        </b-navbar-toggle>
        <b-collapse id="nav_collapse" is-nav>
          <b-navbar-nav :class="`ml-auto  align-items-center h-100 pl-3`">
            <li class="nav-item d-flex align-items-center mr-3">
              <a>
                <b-icon icon="link45deg"></b-icon>
                <br>
                Le site ICDL
              </a>
            </li>
            <li class="nav-item d-flex align-items-center mr-3">
              <a>
              <b-icon icon="film"></b-icon><br>
              {{ $t("menu.demo") }}
              </a>
            </li>

          </b-navbar-nav>

        </b-collapse>

      </b-navbar>



        <div class="logged-out">
          <div class="d-flex justify-content-center align-items-center">
            <b-container fluid class="b-container-fluid">
              <b-row v-if="is_loading" align-h="center">
                <b-card>
                  <b-spinner label="Spinning" class="icdl-blue-inverse"></b-spinner>
                  <b-card-text>
                    Vérification de l'URL en cours
                  </b-card-text>
                </b-card>
              </b-row>
              <b-row v-else-if="!is_formlink_valid" align-h="center">
                <b-card>
                  <b-card-text>
                    <b-alert show variant="danger">L'URL n'est pas valide</b-alert>
                  </b-card-text>
                </b-card>
              </b-row>
              <FormInscription v-else msg="Bienvenue sur le formulaire d'inscription ICDL"
                               :id_site="id_site"
                               :is_editable="is_editable"
                               :form_link="form_link"
                               :auto_validation="auto_validation"
              />
            </b-container>
          </div>


      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import FormInscription from '@/components/Form.vue'
import axios from 'axios';

export default {
  name: 'HomeView',
  props: {
      form_link: {
          type: String,
          default:null
      },
  },
  components: {
      FormInscription
  },
  data(){
    return{
        id_site:null,
        id_formlink:null,
        is_formlink_valid: false,
        access_token:null,
        token_timestamp:0,
        is_loading:true,
        is_editable:false,
        auto_validation:false
    }
  },
    methods:{
      checkCenter(){
          if(this.form_link != null)
          {
              if(this.access_token == null)
              {
                  axios
                      .post(process.env.VUE_APP_API_URL+'/oauth/v2/token', {
                          "client_id": process.env.VUE_APP_CLIENT_ID,
                          "client_secret": process.env.VUE_APP_CLIENT_SECRET,
                          "grant_type": process.env.VUE_APP_GRANT_TYPE
                      })
                      .then((response) => {
                          localStorage.access_token = response.data.access_token;
                          localStorage.token_timestamp = Date.now();
                          let headers = {"Authorization": 'Bearer ' + localStorage.access_token};
                          axios
                              .get(process.env.VUE_APP_API_URL + '/formlink/'+this.form_link,{"headers":headers})
                              .then((response) => {
                                  let formlink = response.data.shift();
                                  localStorage.id_site = parseInt(formlink.id_site);
                                  localStorage.id_formlink = parseInt(formlink.id);
                                  this.is_formlink_valid = true;
                                  this.is_loading = false;
                                  this.is_editable = formlink.editable;
                              }).catch(()=> {
                              localStorage.id_site = null;
                              localStorage.id_formlink = null;

                              this.is_loading = false;
                          });
                      });
              }
              else{
                  let headers = {"Authorization": 'Bearer ' + localStorage.access_token};
                  axios
                      .get(process.env.VUE_APP_API_URL + '/formlink/'+this.form_link,{"headers":headers})
                      .then((response) => {
                          let formlink = response.data.shift();
                          localStorage.id_site = parseInt(formlink.id_site);
                          localStorage.id_formlink = parseInt(formlink.id);
                          this.is_formlink_valid = true;
                          this.is_loading = false;
                          this.is_editable = formlink.editable;
                      }).catch(()=> {
                      localStorage.id_site = null;
                      localStorage.id_formlink = null;

                      this.is_loading = false;
                  });
              }

          }
          else{
              this.is_loading = false;
          }
      },
      getAccessToken(){
          axios
              .post(process.env.VUE_APP_API_URL+'/oauth/v2/token', {
                  "client_id": process.env.VUE_APP_CLIENT_ID,
                  "client_secret": process.env.VUE_APP_CLIENT_SECRET,
                  "grant_type": process.env.VUE_APP_GRANT_TYPE
              })
              .then((response) => {
                  localStorage.access_token = response.data.access_token;
                  localStorage.token_timestamp = Date.now();
              })
      }
    },
    mounted () {
        axios
            .post(process.env.VUE_APP_API_URL+'/oauth/v2/token', {
                "client_id": process.env.VUE_APP_CLIENT_ID,
                "client_secret": process.env.VUE_APP_CLIENT_SECRET,
                "grant_type": process.env.VUE_APP_GRANT_TYPE
            })
            .then((response) => {
                localStorage.access_token = response.data.access_token;
                localStorage.token_timestamp = Date.now();
                let headers = {"Authorization": 'Bearer ' + localStorage.access_token};
                axios
                    .get(process.env.VUE_APP_API_URL + '/formlink/'+this.form_link,{"headers":headers})
                    .then((response) => {
                        let formlink = response.data.shift();
                        localStorage.id_site = parseInt(formlink.id_site);
                        localStorage.id_formlink = parseInt(formlink.id);
                        this.is_formlink_valid = true;
                        this.is_loading = false;
                        this.is_editable = formlink.editable;
                        this.auto_validation = formlink.auto_validation;
                    }).catch(()=> {
                    localStorage.id_site = null;
                    localStorage.id_formlink = null;

                    this.is_loading = false;
                });
            });


    }
}
</script>
<style>

  @import "vue-select/dist/vue-select.css";

  .b-container-fluid{
    margin-top: 8rem !important;
  }
  #app {
    min-height: 100vh;
    background-image: url('../assets/background.jpg');
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
  }

  .icdl-blue{
    background-color: #009FDF !important;
    border-color: #009FDF !important;
    color: #ffffff !important;
  }

  .icdl-blue-inverse{
    background-color: #ffffff;
    color: #009FDF !important;
  }
  .navbar {
    background-color: #ffffff;
    height: 80px;
  }

  .nav-item {
    font-size: 1rem;
    text-decoration: none;
    color: rgba(0,0,0,0.5);
    cursor: pointer;
  }

  .nav-item:hover {
    color: rgba(0,0,0,0.7);
  }
  .navbar-brand {
    height: 100%;
    border-right: 6px solid #f8f9fa;
    padding-right: 2rem;
    display: flex;
    align-items: center;
    margin-right: 0;
  }
  img {
    height: 55px;
  }
  .col-form-label{
    text-align: left !important;
    padding-left: 15px !important;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .multiselect{
    color: #495057 !important;
  }
  .multiselect__tags{
    color: #495057 !important;
    font-size: 1rem;
  }
  .multiselect__placeholder{
    color: #495057 !important;
  }

</style>
